<div class="loader-wrapper">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
    <div class="loader-inner-1"></div>
  </div>
</div>
